import { ROLES } from "@/common/config/acl/roles";

export const FORM_PROGRAMS_PLAYLIST = {
  platformUrl: {
    defaultValue: "",
    read: [
      ROLES.BBB_ADMIN,
      ROLES.BBB_MANAGER_PUBLISHER,
      ROLES.BBB_MANAGER_ADVERTISER,
      ROLES.PUBLISHER_ADMIN,
      ROLES.PUBLISHER_USER,
      ROLES.ADVERTISER_ADMIN,
      ROLES.ADVERTISER_USER
    ],
    write: []
  },
  deleted: {
    defaultValue: false,
    read: [
      ROLES.BBB_ADMIN,
      ROLES.BBB_MANAGER_PUBLISHER,
      ROLES.BBB_MANAGER_ADVERTISER,
      ROLES.PUBLISHER_ADMIN,
      ROLES.PUBLISHER_USER,
      ROLES.ADVERTISER_ADMIN,
      ROLES.ADVERTISER_USER
    ],
    write: [],
    visible: [
      ROLES.BBB_ADMIN,
      ROLES.BBB_MANAGER_PUBLISHER,
      ROLES.BBB_MANAGER_ADVERTISER,
      ROLES.PUBLISHER_ADMIN,
      ROLES.ADVERTISER_ADMIN
    ]
  },
  homeDisplay: {
    read: [
      ROLES.BBB_ADMIN,
      ROLES.BBB_MANAGER_PUBLISHER,
      ROLES.BBB_MANAGER_ADVERTISER,
      ROLES.PUBLISHER_ADMIN,
      ROLES.PUBLISHER_USER,
      ROLES.ADVERTISER_ADMIN,
      ROLES.ADVERTISER_USER
    ],
    write: [
      ROLES.BBB_ADMIN,
      ROLES.BBB_MANAGER_PUBLISHER,
      ROLES.BBB_MANAGER_ADVERTISER,
      ROLES.PUBLISHER_ADMIN,
      ROLES.PUBLISHER_USER,
      ROLES.ADVERTISER_ADMIN,
      ROLES.ADVERTISER_USER
    ]
  },
  status: {
    defaultValue: true,
    read: [
      ROLES.BBB_ADMIN,
      ROLES.BBB_MANAGER_PUBLISHER,
      ROLES.BBB_MANAGER_ADVERTISER,
      ROLES.PUBLISHER_ADMIN,
      ROLES.PUBLISHER_USER,
      ROLES.ADVERTISER_ADMIN,
      ROLES.ADVERTISER_USER
    ],
    write: [
      ROLES.BBB_ADMIN,
      ROLES.BBB_MANAGER_PUBLISHER,
      ROLES.BBB_MANAGER_ADVERTISER,
      ROLES.PUBLISHER_ADMIN,
      ROLES.PUBLISHER_USER,
      ROLES.ADVERTISER_ADMIN,
      ROLES.ADVERTISER_USER
    ]
  },
  playlist: {
    defaultValue: {},
    read: [
      ROLES.BBB_ADMIN,
      ROLES.BBB_MANAGER_PUBLISHER,
      ROLES.BBB_MANAGER_ADVERTISER,
      ROLES.PUBLISHER_ADMIN,
      ROLES.PUBLISHER_USER,
      ROLES.ADVERTISER_ADMIN,
      ROLES.ADVERTISER_USER
    ],
    write: []
  },
  url: {
    defaultValue: "",
    read: [
      ROLES.BBB_ADMIN,
      ROLES.BBB_MANAGER_PUBLISHER,
      ROLES.BBB_MANAGER_ADVERTISER,
      ROLES.PUBLISHER_ADMIN,
      ROLES.PUBLISHER_USER,
      ROLES.ADVERTISER_ADMIN,
      ROLES.ADVERTISER_USER
    ],
    write: [ROLES.BBB_ADMIN]
  },
  authorLink: {
    defaultValue: "",
    read: [
      ROLES.BBB_ADMIN,
      ROLES.BBB_MANAGER_PUBLISHER,
      ROLES.BBB_MANAGER_ADVERTISER,
      ROLES.PUBLISHER_ADMIN,
      ROLES.PUBLISHER_USER,
      ROLES.ADVERTISER_ADMIN,
      ROLES.ADVERTISER_USER
    ],
    write: [
      ROLES.BBB_ADMIN,
      ROLES.BBB_MANAGER_PUBLISHER,
      ROLES.PUBLISHER_ADMIN,
      ROLES.PUBLISHER_USER
    ]
  },
  urlHash: {
    defaultValue: "",
    read: [
      ROLES.BBB_ADMIN,
      ROLES.BBB_MANAGER_PUBLISHER,
      ROLES.BBB_MANAGER_ADVERTISER,
      ROLES.PUBLISHER_ADMIN,
      ROLES.PUBLISHER_USER,
      ROLES.ADVERTISER_ADMIN,
      ROLES.ADVERTISER_USER
    ],
    write: [ROLES.BBB_ADMIN]
  },
  id: {
    defaultValue: "",
    read: [
      ROLES.BBB_ADMIN,
      ROLES.BBB_MANAGER_PUBLISHER,
      ROLES.BBB_MANAGER_ADVERTISER,
      ROLES.PUBLISHER_ADMIN,
      ROLES.PUBLISHER_USER,
      ROLES.ADVERTISER_ADMIN,
      ROLES.ADVERTISER_USER
    ],
    write: [ROLES.BBB_ADMIN]
  },
  name: {
    defaultValue: "",
    read: [
      ROLES.BBB_ADMIN,
      ROLES.BBB_MANAGER_PUBLISHER,
      ROLES.BBB_MANAGER_ADVERTISER,
      ROLES.PUBLISHER_ADMIN,
      ROLES.PUBLISHER_USER,
      ROLES.ADVERTISER_ADMIN,
      ROLES.ADVERTISER_USER
    ],
    write: [
      ROLES.BBB_ADMIN,
      ROLES.BBB_MANAGER_PUBLISHER,
      ROLES.PUBLISHER_ADMIN,
      ROLES.PUBLISHER_USER,
      ROLES.ADVERTISER_ADMIN,
      ROLES.ADVERTISER_USER
    ]
  },
  title: {
    defaultValue: "",
    read: [
      ROLES.BBB_ADMIN,
      ROLES.BBB_MANAGER_PUBLISHER,
      ROLES.BBB_MANAGER_ADVERTISER,
      ROLES.PUBLISHER_ADMIN,
      ROLES.PUBLISHER_USER,
      ROLES.ADVERTISER_ADMIN,
      ROLES.ADVERTISER_USER
    ],
    write: [
      ROLES.BBB_ADMIN,
      ROLES.BBB_MANAGER_PUBLISHER,
      ROLES.PUBLISHER_ADMIN,
      ROLES.PUBLISHER_USER,
      ROLES.ADVERTISER_ADMIN,
      ROLES.ADVERTISER_USER
    ]
  },
  description: {
    defaultValue: "",
    read: [
      ROLES.BBB_ADMIN,
      ROLES.BBB_MANAGER_PUBLISHER,
      ROLES.BBB_MANAGER_ADVERTISER,
      ROLES.PUBLISHER_ADMIN,
      ROLES.PUBLISHER_USER,
      ROLES.ADVERTISER_ADMIN,
      ROLES.ADVERTISER_USER
    ],
    write: [
      ROLES.BBB_ADMIN,
      ROLES.BBB_MANAGER_PUBLISHER,
      ROLES.PUBLISHER_ADMIN,
      ROLES.PUBLISHER_USER,
      ROLES.ADVERTISER_ADMIN,
      ROLES.ADVERTISER_USER
    ]
  },
  isExplicit: {
    defaultValue: false,
    read: [
      ROLES.BBB_ADMIN,
      ROLES.BBB_MANAGER_PUBLISHER,
      ROLES.BBB_MANAGER_ADVERTISER,
      ROLES.PUBLISHER_ADMIN,
      ROLES.PUBLISHER_USER,
      ROLES.ADVERTISER_ADMIN,
      ROLES.ADVERTISER_USER
    ],
    write: [
      ROLES.BBB_ADMIN,
      ROLES.BBB_MANAGER_PUBLISHER,
      ROLES.PUBLISHER_ADMIN,
      ROLES.PUBLISHER_USER
    ]
  },
  ownerEmail: {
    defaultValue: "",
    read: [
      ROLES.BBB_ADMIN,
      ROLES.BBB_MANAGER_PUBLISHER,
      ROLES.BBB_MANAGER_ADVERTISER,
      ROLES.PUBLISHER_ADMIN,
      ROLES.PUBLISHER_USER,
      ROLES.ADVERTISER_ADMIN,
      ROLES.ADVERTISER_USER
    ],
    write: [
      ROLES.BBB_ADMIN,
      ROLES.BBB_MANAGER_PUBLISHER,
      ROLES.PUBLISHER_ADMIN,
      ROLES.PUBLISHER_USER,
      ROLES.ADVERTISER_ADMIN,
      ROLES.ADVERTISER_USER
    ]
  },
  keywords: {
    defaultValue: "",
    read: [
      ROLES.BBB_ADMIN,
      ROLES.BBB_MANAGER_PUBLISHER,
      ROLES.BBB_MANAGER_ADVERTISER,
      ROLES.PUBLISHER_ADMIN,
      ROLES.PUBLISHER_USER,
      ROLES.ADVERTISER_ADMIN,
      ROLES.ADVERTISER_USER
    ],
    write: [
      ROLES.BBB_ADMIN,
      ROLES.BBB_MANAGER_PUBLISHER,
      ROLES.BBB_MANAGER_ADVERTISER,
      ROLES.PUBLISHER_ADMIN,
      ROLES.PUBLISHER_USER,
      ROLES.ADVERTISER_ADMIN,
      ROLES.ADVERTISER_USER
    ]
  },
  image: {
    defaultValue: "",
    read: [
      ROLES.BBB_ADMIN,
      ROLES.BBB_MANAGER_PUBLISHER,
      ROLES.BBB_MANAGER_ADVERTISER,
      ROLES.PUBLISHER_ADMIN,
      ROLES.PUBLISHER_USER,
      ROLES.ADVERTISER_ADMIN,
      ROLES.ADVERTISER_USER
    ],
    write: [
      ROLES.BBB_ADMIN,
      ROLES.BBB_MANAGER_PUBLISHER,
      ROLES.PUBLISHER_ADMIN,
      ROLES.PUBLISHER_USER
    ]
  },
  language: {
    defaultValue: "fr",
    read: [
      ROLES.BBB_ADMIN,
      ROLES.BBB_MANAGER_PUBLISHER,
      ROLES.BBB_MANAGER_ADVERTISER,
      ROLES.PUBLISHER_ADMIN,
      ROLES.PUBLISHER_USER,
      ROLES.ADVERTISER_ADMIN,
      ROLES.ADVERTISER_USER
    ],
    write: [
      ROLES.BBB_ADMIN,
      ROLES.BBB_MANAGER_PUBLISHER,
      ROLES.BBB_MANAGER_ADVERTISER,
      ROLES.PUBLISHER_ADMIN,
      ROLES.PUBLISHER_USER,
      ROLES.ADVERTISER_ADMIN,
      ROLES.ADVERTISER_USER
    ]
  },
  type: {
    defaultValue: "episodic",
    read: [
      ROLES.BBB_ADMIN,
      ROLES.BBB_MANAGER_PUBLISHER,
      ROLES.BBB_MANAGER_ADVERTISER,
      ROLES.PUBLISHER_ADMIN,
      ROLES.PUBLISHER_USER,
      ROLES.ADVERTISER_ADMIN,
      ROLES.ADVERTISER_USER
    ],
    write: [
      ROLES.BBB_ADMIN,
      ROLES.BBB_MANAGER_PUBLISHER,
      ROLES.PUBLISHER_ADMIN,
      ROLES.PUBLISHER_USER
    ]
  },
  author: {
    defaultValue: "",
    read: [
      ROLES.BBB_ADMIN,
      ROLES.BBB_MANAGER_PUBLISHER,
      ROLES.BBB_MANAGER_ADVERTISER,
      ROLES.PUBLISHER_ADMIN,
      ROLES.PUBLISHER_USER,
      ROLES.ADVERTISER_ADMIN,
      ROLES.ADVERTISER_USER
    ],
    write: [
      ROLES.BBB_ADMIN,
      ROLES.BBB_MANAGER_PUBLISHER,
      ROLES.PUBLISHER_ADMIN,
      ROLES.PUBLISHER_USER
    ]
  },
  programDomains: {
    defaultValue: "",
    read: [
      ROLES.BBB_ADMIN,
      ROLES.BBB_MANAGER_PUBLISHER,
      ROLES.BBB_MANAGER_ADVERTISER,
      ROLES.PUBLISHER_ADMIN,
      ROLES.PUBLISHER_USER,
      ROLES.ADVERTISER_ADMIN,
      ROLES.ADVERTISER_USER
    ],
    write: [
      ROLES.BBB_ADMIN,
      ROLES.BBB_MANAGER_PUBLISHER,
      ROLES.BBB_MANAGER_ADVERTISER,
      ROLES.PUBLISHER_ADMIN,
      ROLES.PUBLISHER_USER,
      ROLES.ADVERTISER_ADMIN,
      ROLES.ADVERTISER_USER
    ]
  },
  domainObject: {
    defaultValue: "",
    read: [
      ROLES.BBB_ADMIN,
      ROLES.BBB_MANAGER_PUBLISHER,
      ROLES.BBB_MANAGER_ADVERTISER,
      ROLES.PUBLISHER_ADMIN,
      ROLES.PUBLISHER_USER,
      ROLES.ADVERTISER_ADMIN,
      ROLES.ADVERTISER_USER
    ],
    write: [
      ROLES.BBB_ADMIN,
      ROLES.BBB_MANAGER_PUBLISHER,
      ROLES.BBB_MANAGER_ADVERTISER,
      ROLES.PUBLISHER_ADMIN,
      ROLES.PUBLISHER_USER,
      ROLES.ADVERTISER_ADMIN,
      ROLES.ADVERTISER_USER
    ]
  },
  itunesSubCategories: {
    defaultValue: "",
    read: [
      ROLES.BBB_ADMIN,
      ROLES.BBB_MANAGER_PUBLISHER,
      ROLES.BBB_MANAGER_ADVERTISER,
      ROLES.PUBLISHER_ADMIN,
      ROLES.PUBLISHER_USER,
      ROLES.ADVERTISER_ADMIN,
      ROLES.ADVERTISER_USER
    ],
    write: [
      ROLES.BBB_ADMIN,
      ROLES.BBB_MANAGER_PUBLISHER,
      ROLES.PUBLISHER_ADMIN,
      ROLES.PUBLISHER_USER
    ]
  },
  brand: {
    defaultValue: null,
    read: [
      ROLES.BBB_ADMIN,
      ROLES.BBB_MANAGER_PUBLISHER,
      ROLES.BBB_MANAGER_ADVERTISER
    ],
    write: []
  }
};

export const FORM_ADVERTISEMENT_PLAYLIST = {
  authorizedAds: {
    defaultValue: false,
    read: [ROLES.BBB_ADMIN, ROLES.BBB_MANAGER_PUBLISHER],
    write: [ROLES.BBB_ADMIN, ROLES.BBB_MANAGER_PUBLISHER]
  },
  authorizedAudioAds: {
    defaultValue: false,
    read: [
      ROLES.BBB_ADMIN,
      ROLES.BBB_MANAGER_PUBLISHER,
      ROLES.BBB_MANAGER_ADVERTISER
    ],
    write: [ROLES.BBB_ADMIN]
  },
  audioAdsBackfilled: {
    defaultValue: false,
    read: [
      ROLES.BBB_ADMIN,
      ROLES.BBB_MANAGER_PUBLISHER,
      ROLES.BBB_MANAGER_ADVERTISER
    ],
    write: [
      ROLES.BBB_ADMIN,
      ROLES.BBB_MANAGER_PUBLISHER,
      ROLES.BBB_MANAGER_ADVERTISER
    ]
  },
  audioAdsUrl: {
    defaultValue: null,
    read: [
      ROLES.BBB_ADMIN,
      ROLES.BBB_MANAGER_PUBLISHER,
      ROLES.BBB_MANAGER_ADVERTISER
    ],
    write: [ROLES.BBB_ADMIN]
  },
  audioAdsConfiguration: {
    defaultValue: "{}",
    read: [
      ROLES.BBB_ADMIN,
      ROLES.BBB_MANAGER_PUBLISHER,
      ROLES.BBB_MANAGER_ADVERTISER
    ],
    write: [ROLES.BBB_ADMIN]
  },
  capping: {
    read: [
      ROLES.BBB_ADMIN,
      ROLES.BBB_MANAGER_PUBLISHER,
      ROLES.BBB_MANAGER_ADVERTISER,
      ROLES.PUBLISHER_ADMIN,
      ROLES.PUBLISHER_USER,
      ROLES.ADVERTISER_ADMIN,
      ROLES.ADVERTISER_USER
    ],
    write: [
      ROLES.BBB_ADMIN,
      ROLES.BBB_MANAGER_PUBLISHER,
      ROLES.BBB_MANAGER_ADVERTISER,
      ROLES.PUBLISHER_ADMIN
    ]
  },
  brand: {
    defaultValue: null,
    read: [
      ROLES.BBB_ADMIN,
      ROLES.BBB_MANAGER_PUBLISHER,
      ROLES.BBB_MANAGER_ADVERTISER
    ],
    write: [
      ROLES.BBB_ADMIN,
      ROLES.BBB_MANAGER_PUBLISHER,
      ROLES.BBB_MANAGER_ADVERTISER
    ]
  }
};

export const FORM_ADVANCED_PLAYLIST = {
  homeDisplay: {
    read: [
      ROLES.BBB_ADMIN,
      ROLES.BBB_MANAGER_PUBLISHER,
      ROLES.BBB_MANAGER_ADVERTISER,
      ROLES.PUBLISHER_ADMIN,
      ROLES.PUBLISHER_USER,
      ROLES.ADVERTISER_ADMIN,
      ROLES.ADVERTISER_USER
    ],
    write: [
      ROLES.BBB_ADMIN,
      ROLES.BBB_MANAGER_PUBLISHER,
      ROLES.BBB_MANAGER_ADVERTISER,
      ROLES.PUBLISHER_ADMIN,
      ROLES.PUBLISHER_USER,
      ROLES.ADVERTISER_ADMIN,
      ROLES.ADVERTISER_USER
    ]
  },
  isForced: {
    read: [
      ROLES.BBB_ADMIN,
      ROLES.BBB_MANAGER_PUBLISHER,
      ROLES.BBB_MANAGER_ADVERTISER
    ],
    write: [
      ROLES.BBB_ADMIN,
      ROLES.BBB_MANAGER_PUBLISHER,
      ROLES.BBB_MANAGER_ADVERTISER
    ]
  },
  cluster: {
    read: [
      ROLES.BBB_ADMIN,
      ROLES.BBB_MANAGER_PUBLISHER,
      ROLES.BBB_MANAGER_ADVERTISER
    ],
    write: [
      ROLES.BBB_ADMIN,
      ROLES.BBB_MANAGER_PUBLISHER,
      ROLES.BBB_MANAGER_ADVERTISER
    ]
  },
  parentId: {
    read: [
      ROLES.BBB_ADMIN,
      ROLES.BBB_MANAGER_PUBLISHER,
      ROLES.BBB_MANAGER_ADVERTISER,
      ROLES.PUBLISHER_ADMIN,
      ROLES.PUBLISHER_USER,
      ROLES.ADVERTISER_ADMIN,
      ROLES.ADVERTISER_USER
    ],
    write: [ROLES.BBB_ADMIN, ROLES.BBB_MANAGER_PUBLISHER]
  },
  tags: {
    read: [
      ROLES.BBB_ADMIN,
      ROLES.BBB_MANAGER_PUBLISHER,
      ROLES.BBB_MANAGER_ADVERTISER
    ],
    write: [
      ROLES.BBB_ADMIN,
      ROLES.BBB_MANAGER_PUBLISHER,
      ROLES.BBB_MANAGER_ADVERTISER
    ]
  },
  redirectTo: {
    read: [
      ROLES.BBB_ADMIN,
      ROLES.BBB_MANAGER_PUBLISHER,
      ROLES.BBB_MANAGER_ADVERTISER
    ],
    write: [ROLES.BBB_ADMIN]
  }
};
